import * as types from '../constants/ActionTypes'
import api from '../utils/api'
import {actions as kandyActions} from 'kandy-redux'
/*
 * SERVICE REQUEST Action Creators
 */


/**
 * LOAD_SERVICE_REQUESTS action
 * Used to load any pending service requests in state. It is triggered only on LOGIN_FINISH
 * @params {Object} serviceRequests - service requests to be loaded in state
 */
let loadRequests = (serviceRequests) => {
    return {
        type: types.LOAD_SERVICE_REQUESTS,
        payload: {
            serviceRequests: serviceRequests
        }
    }
}


/**
 * END_SESSION action
 * Used to end the session with a customer
 */
let endSession = (userId) => {
	return (dispatch, getState) => {
		let url = '/serviceRequests/endSession'

		var appState = getState().app
		var customer = appState.customers.current.filter(customer => customer.userId === userId)[0]
		if (customer && customer._id) {
			api(url)
				.post({id: customer._id})
				.then(serviceRequest => dispatch(endSessionFinish(userId)))
				.catch(err => {

				})
		}
	}
}

let endSessionFinish = (userId) => {

	return {
		type: types.END_SESSION,
		payload: {userId}
	}
}

let changeActiveCustomer = (requestId) => {
	return {
		type: types.CHANGE_ACTIVE_CUSTOMER,
		payload: {requestId}
	}
}

let makeCallInitiate = (userId) => {
	return {
		type: types.MAKE_KANDY_CALL,
		payload: {userId}
	}
}

let endCallInitiate = (userId, callId) => {
	return {
		type: types.END_KANDY_CALL,
		payload: {userId, callId}
	}
}

let makeKandyCall = (userId, cameraOn, callerId, options) => {
	return dispatch => {
		dispatch(makeCallInitiate(userId))
		dispatch(kandyActions.makeCall(userId, cameraOn, callerId, options))
	}
}

let sendIsShowShade = (userId,isShowShade) =>{
	return{
		type:types.ISSHOW_CALL_SHADE,
		payload:{userId,isShowShade}
	}
}

let endKandyCall = (userId, callId) => {
    return (dispatch, getState) => {
        let companyId = getState().company.id
        let endAt = new Date().getTime()
		let call = getState().app.kandy.calls[0]
		if(call&&call.status=="established"){

            let id = getState().app.chatMessageCall.call._id
            let message = getState().app.chatMessageCall.call.message||{}
            message.additional_data||(message.additional_data={})
            message.additional_data.endAt=endAt
            let req ={
                "id":id,
                "message" :message,
                "timestamp":endAt,
            }
            api( '/' + companyId + '/chatMessages/updateCallMessage')
                .put(Object.assign(req))
                .then(response =>{

                    }
                )
                .catch(err => {

                })
		}
        dispatch(endCallInitiate(userId, callId))
        dispatch(kandyActions.endCall(callId))

    }
}

let cancelServiceRequest = (requestId) => {
	return dispatch => {
		dispatch(cancelServiceRequestInitiate(requestId))
		api('/cancelServiceRequest/' + requestId)
			.put()
			.then(serviceRequest =>dispatch(cancelServiceRequestFinish(requestId))
			)
	}
}

let clearServiceRequests = () => {
    return dispatch => {
        dispatch({
            type: types.CLEAR_SERVICE_REQUESTS,
            payload: ''
        })
    }
}

let cancelServiceRequestInitiate = (requestId) => {
	return {
		type: types.CANCEL_SERVICE_REQUEST,
		payload: {requestId}
	}
}

let cancelServiceRequestFinish = (requestId) => {
	return {
		type: types.CANCEL_SERVICE_REQUEST_FINISH,
		payload: {requestId}
	}
}


//update userInfo
let updateCustomerId = (req) =>{
	var url = '/serviceRequests/updateCustomerId/'+req._id;
	return dispatch => {
		return api(url).put(req)
			.then(response =>{
                dispatch(updateCustomerIdFinish(response))
			}
		)
			.catch(err => {

                dispatch(updateCustomerIdFinish({errCode:-1}))
			})
	}
}



let updateCustomerIdFinish = (response) =>{
    if (response.errCode==0) {
        return {
            type: types.UPDATE_CUSTOMER_ID,
            payload: {
                requestUserInfo:response.result
            }
        }
    }else{
        return{
            type: types.UPDATE_CUSTOMER_ID,
            payload: {},
            error: true
        }
    }
}


let updateEscalatedServiceRequestFinish = (serviceRequest) => {
	if(serviceRequest.errCode==0){
        return {
            type: types.UPDATE_ESCALATED_SERVICE_REQUEST,
            payload: {serviceRequest:serviceRequest.result}
        }
	}else {
        return {
            type: types.UPDATE_ESCALATED_SERVICE_REQUEST,
            payload: {},
			error:true
        }
	}

}

let updateServiceRequests = (data) => {
	return {
		type: types.UPDATE_SERVICE_REQUESTS,
		payload: {data}
	}
}

let closeGrabSingleWarning=()=>{
	return {
		type: types.CLOSE_GRAB_SINGLE_WARNING,
		payload: {  }
	}
}
let updateMsgBoard = (payload) => {
	console.log('updateMsgBoard', payload)
	return {
		type: 'updateMsg',
		payload: {...payload}
	}
}
/**
 * Functions that are to be exported by default
 */
export default {
	loadRequests,
	endSession,
	endSessionFinish,
	changeActiveCustomer,
	makeKandyCall,
	endKandyCall,
	cancelServiceRequest,
    clearServiceRequests,
	updateServiceRequests,
	updateCustomerId,
	sendIsShowShade,
	closeGrabSingleWarning,
    cancelServiceRequestInitiate,
    cancelServiceRequestFinish,
		updateMsgBoard
}
